import * as React from "react";
import { Modal, ModalBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import Text from "../common/input/text";
import Select from "../common/input/select";
import DatePicker from "../common/DatePicker";
import GenericInput from "../common/input/GenericInput";
import SSNInput from "../common/input/SSNInput";
import PhoneNumber from "../common/input/PhoneNumber";
import LocationSearchInput from "../common/input/LocationSearchInput";
import { translateText } from '../../helpers/data';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import ZipCode from "../common/input/ZipInput";
import Email from '../common/input/Email';
const dobInputId = "dobInput";
const genderInputId = "genderInput";
const ssnInputId = "ssnInput";
const phoneInputId = "phoneInput";
const insuranceInputId = "insuranceInput";
const notListedInsuranceInputId = "notListedInsuranceInput";
const emailInputId = "emailInput";
const addressInputId = "addressInput";

class PatientInfo extends React.Component {

    constructor(props, context) {
        super(props, context);

        const { dateOfBirth, gender, nationalIdentifier, phoneNumbers, insurance, notListedInsuranceName, mailingAddress, email } = props.model;

        this.state = {
            dateOfBirth: dateOfBirth ? dateOfBirth : '',
            gender: gender ? gender : '',
            nationalIdentifier: nationalIdentifier ? nationalIdentifier : '',
            patientPhone: phoneNumbers && phoneNumbers.length > 0 ? phoneNumbers[0].number : '',
            insuranceName: notListedInsuranceName ? 'Not Listed' : (insurance && insurance.insuranceName ? insurance.insuranceName : ''),
            notListedInsuranceName: notListedInsuranceName ? notListedInsuranceName : '',
            memberId: insurance && insurance.memberNumber ? insurance.memberNumber : '',
            subscriberId: insurance && insurance.subscriberId ? insurance.subscriberId : '',
            groupNumber: insurance && insurance.groupNumber ? insurance.groupNumber : '',
            mailingAddress: mailingAddress ? mailingAddress : null,
            isShowManualAddress: mailingAddress && mailingAddress.zip && !mailingAddress.longAddress ? true : false,
            validDob: true, validGender: true, validSsn: true, validPhone: true,
            validInsurance: true, validInsuranceNotListed: true, validMailingAddress: (mailingAddress && mailingAddress.longAddress) ? true : false,
            email: email ? { value: email, isValid: true } : { value: '', isValid: false },
            validationError: "",
            mounted: false,
            showMammogramWithoutMyChartModal:  false
        };

        // we're adding our own continue button here...
        //this.props.disableEnableContinueButton(true);

        this.savePatientInfo = this.savePatientInfo.bind(this);
        this.stupidDatePickerHack = this.stupidDatePickerHack.bind(this);
        this.notifyToEnterAddressManually = this.notifyToEnterAddressManually.bind(this);
        //this.is_Validated = this.is_Validated.bind(this);
        this.setValidationMessage = this.setValidationMessage.bind(this);
        //this.inputId = dobInputId;
        this.genderHasFocused = false;
    }

    componentDidMount() {
        logUI("MBHWeb.UI.PatientInfo.ComponentDidMount", new Date(), Tools.getURLPath());
        this.setState({ mounted: true });
        //this.valid = this.isValid();
        //if (this.props.isValid) {
        //    this.props.isValid(this.valid);
        //}
    }

    componentDidUpdate() {       

        //Gender need auto focus if blank when this step loads / displays to user
        if (this.state.mounted && !this.genderHasFocused && this.refs && this.refs.gender && this.refs.gender.refs && this.refs.gender.refs.selectElement) {
            this.refs.gender.refs.selectElement.focus();
        }
    }

    componentWillUnmount() {
        this.setState({ mounted: false });
    }

    // Added this method as OurStepManager calls isValid() to change the classes of the Progress Bar
    isValid() {
        return this.isValidate(false);
    }

    //Below method will handle this issue "Patient Info- User is not able to enter the information in fields in any order."
    onGoNext(success) {
        if (success) {
            this.savePatientInfo();
        }
        else {
            this.setState({ showAsInvalid: true });
        }
    }

    notifyToEnterAddressManually() {
        const { mounted } = this.state;
        if (mounted) {
            this.setState({ isShowManualAddress: true });
        }
    }

    savePatientInfo() {
        const { userHasEmail } = this.props;
        try {
            let model = {
                nationalIdentifier: this.state.nationalIdentifier,
                dateOfBirth: this.state.dateOfBirth,
                gender: this.state.gender,
                phoneNumbers: this.state.patientPhone ? [{ number: this.state.patientPhone.replace(/\./ig, ''), type: "Home Phone" }] : null,
                mailingAddress: this.state.mailingAddress
            };

            if (this.state.mailingAddress) {
                model.houseNumber = this.state.mailingAddress.streetNumber;
                model.streetLine1 = this.state.mailingAddress.streetNumber + " " + this.state.mailingAddress.street;
                model.streetLine2 = this.state.mailingAddress.street2;
                model.city = this.state.mailingAddress.city;
                model.state = this.state.mailingAddress.state;
                model.zipCode = this.state.mailingAddress.zip;
            }

            if (!userHasEmail) model.email = this.state.email.value;

            const isInsuranceNotListed = this.state.insuranceName.toLowerCase() === "not listed";
            model.notListedInsuranceName = isInsuranceNotListed ? this.state.notListedInsuranceName : '';
            if (this.state.insuranceName !== "") {
                model.insurance = {
                    insuranceName: isInsuranceNotListed ? this.state.notListedInsuranceName : this.state.insuranceName,
                    memberNumber: this.state.memberId,
                    groupNumber: this.state.groupNumber,
                    subscriberId: this.state.subscriberId
                };
            }

            this.props.savePatientInfo(model);

            return true;
        }
        catch {
            return false;
        }
    }

    stupidDatePickerHack(dt) {
        // turn a string containing YYYY-MM-DD into one containing MM/DD/YYYY
        let parts = dt.split('-');
        return parts && parts.length > 1 ? `${parts[1].toString().padStart(2, "0")}/${parts[2].toString().padStart(2, "0")}/${parts[0]}` : null;
    }

    digits(str, length) {
        return str.replace(/[^0-9]/g, '').length >= length;
    }

    setValidationMessage(sMessage) {
        const { validationError, mounted } = this.state;
        if (mounted && validationError !== sMessage) {
            this.setState({ validationError: sMessage });
        }
    }

    isValidate(fromInput) {
        const { mounted } = this.state;
        if (mounted) {
            const { dateOfBirth, gender, nationalIdentifier, patientPhone, insuranceName, notListedInsuranceName, mailingAddress, email, validMailingAddress, isShowManualAddress } = this.state;
            const { userHasEmail, translate, t } = this.props;
            let validDob, validGender, validSsn, validPhone, validInsurance, validInsuranceNotListed, isStreetNumberValid, isStreetValid, isCityValid, isStateValid, isZipValid;

            validDob = this.digits(dateOfBirth, 6);
            validGender = gender.trim() !== '';

            validSsn = nationalIdentifier.trim() === '' || this.digits(nationalIdentifier, 9);
            validPhone = this.digits(patientPhone, 10);
            validInsurance = insuranceName !== '';
            validInsuranceNotListed = insuranceName !== 'Not Listed' || notListedInsuranceName.trim() !== '';

            if (userHasEmail) {
                if (!this.state.email || !this.state.email.isValid) {
                    this.setState({
                        email: { isValid: true }
                    });
                }
            }

            if (isShowManualAddress) {
                isStreetNumberValid = mailingAddress.streetNumber !== '';
                isStreetValid = mailingAddress.street !== '';
                isCityValid = mailingAddress.city !== '';
                isStateValid = mailingAddress.state !== '';
                isZipValid = mailingAddress.zip !== '' && mailingAddress.zip.length === 5;
            }

            if (validDob !== this.state.validDob ||
                validGender !== this.state.validGender ||
                validSsn !== this.state.validSsn ||
                validPhone !== this.state.validPhone ||
                validInsurance !== this.state.validInsurance ||
                validInsuranceNotListed !== this.state.validInsuranceNotListed ||
                isStreetNumberValid !== this.state.isStreetNumberValid ||
                isStreetValid !== this.state.isStreetValid ||
                isStateValid !== this.state.isStateValid ||
                isZipValid !== this.state.isZipValid
            ) {
                this.setState({ validDob, validGender, validSsn, validPhone, validInsurance, validInsuranceNotListed, isStreetNumberValid, isStreetValid, isCityValid, isStateValid, isZipValid });
            }

            //if (!validDob) this.inputId = dobInputId;
            //else if (!validGender) this.inputId = genderInputId;
            //else if (!validSsn) this.inputId = ssnInputId;
            //else if (!validPhone) this.inputId = phoneInputId;
            //else if (!validInsurance) this.inputId = insuranceInputId;
            //else if (!validInsuranceNotListed) this.inputId = notListedInsuranceInputId;
            //else if (!isShowManualAddress && !validMailingAddress) this.inputId = addressInputId;
            //else if (!this.state.email.isValid) this.inputId = emailInputId;

            if (!fromInput) {
                if (!validDob) {
                    //debugger;
                    this.setValidationMessage(translateText(t && translate, "You must select a valid date of birth.", t));
                    return false;
                }
                if (!validGender) {
                    //debugger;
                    this.setValidationMessage(translateText(t && translate, "You must select a gender.", t));
                    //this.refs.gender.refs.selectElement.focus();
                    return false;
                }
                if (!validSsn) {
                    this.setValidationMessage(translateText(t && translate, "You must enter a valid social security number.", t));
                    //this.refs.SSN.refs.inputElement.focus();
                    return false;
                }
                if (!validPhone) {
                    this.setValidationMessage(translateText(t && translate, "You must enter a valid phone number.", t));
                    //this.refs.phone.refs.inputElement.focus();
                    return false;
                }
                if (!isShowManualAddress && !validMailingAddress) {
                    //debugger;
                    this.setValidationMessage(translateText(t && translate, "You must enter a valid address.", t));
                    let oAddr = Tools.getRootRef(this.refs.address);
                    //oAddr.inputElement.focus();  // we can't autofocus this control
                    return false;
                }
            }

            return validDob && validGender && validSsn && validPhone && validInsurance && validInsuranceNotListed && (userHasEmail || email.isValid)
                && (isShowManualAddress ? isStreetNumberValid && isStreetValid && isCityValid && isStateValid && isZipValid : validMailingAddress);
        }

    }

    /*is_Validated() {
        const valid = this.isValid();
        if (valid) {
            return this.createPatient();
        }
        else {
            const input = document.getElementById(this.inputId);
            if (input) {
                input.focus();
            }
        }
        this.setState({ showAsInvalid: !valid });
        return valid;
    }*/

    /*validate(valid, fromInput) {
        valid = (typeof valid === 'undefined' || valid) && this.isValid(fromInput);
        if (this.valid !== valid) {
            this.valid = valid;
            if (this.props.isValid) {
                this.props.isValid(valid);
            }
        }
    }*/

    onInputChange(field, value, isValid) {
        const {isMammogramSchedule} = this.props;
        if (typeof isValid === 'undefined' || isValid) {
            if (isMammogramSchedule && field === "gender" && value === "Male") {
                this.props.onFemalePatientSelected(false);
                this.setState({ showMammogramWithoutMyChartModal: true});
            } else if (isMammogramSchedule && field === "gender" && value === "Female") {
                this.props.onFemalePatientSelected(true);
                this.setState({ showMammogramWithoutMyChartModal: false, [field]: value }, () => this.isValidate(true));
            } else {
                this.setState({ [field]: value }, () => this.isValidate(true));
            }
        }
        else {
            this.isValidate(true);
        }
    }

    hideModal = () => {
        this.setState({ showMammogramWithoutMyChartModal: false, gender: "" })
    }

    onGenderFocus(event) {
        if (!this.genderHasFocused) {
            this.genderHasFocused = true;
        }
    }

    render() {
        const { mailingAddress, isShowManualAddress, email, validationError, showMammogramWithoutMyChartModal } = this.state;
        const { userHasEmail, isMammogramSchedule, translate, t } = this.props;
        let renderEmail = false;
        if (userHasEmail === false || userHasEmail === null || userHasEmail === undefined || userHasEmail === "")
            renderEmail = true;
        let insurancePlans = [...this.props.insurancePlans];
        insurancePlans.push({ key: insurancePlans.length, value: "Not Listed", label: translateText(t && translate, "Not Listed", t)});
        insurancePlans.push({ key: insurancePlans.length, value: "No Insurance", label: translateText(t && translate, "No Insurance", t) });

        const maleMammogramCurrentMsg = translateText(t && translate, "Currently, our system has a different process for scheduling screening mammograms for individuals who do not identify as female.", t);
        const maleMammogramAssistantMsg = translateText(t && translate, "For further assistance please contact your primary care provider.", t)

        return (
            <div className="schedule-patient-info-container" style={this.props.style}>
                {
                     isMammogramSchedule && showMammogramWithoutMyChartModal && (
                        <Modal className="mammogram-assistance-modal" isOpen={showMammogramWithoutMyChartModal} centered>
                            <ModalBody>
                                <span className="mammogram-msg">{maleMammogramCurrentMsg}</span><br/><br/>
                                <span className="mammogram-msg">{maleMammogramAssistantMsg}</span>
                                <div className="col-12 navigation-btns">
                                    <Link className="btn btn-primary" to={'/'}>{translateText(t && translate, "BACK TO DASHBOARD", t) }</Link>
                                    <a className="btn btn-primary" onClick={this.hideModal}>{translateText(t && translate, "CLOSE", t) }</a> 
                                </div>
                            </ModalBody>
                        </Modal>
                    )
                }
                <div className="row">
                    <div className="col-12">
                        <h1 className="step-heading">{translateText(t && translate, "Please confirm your information and fill in the missing fields.", t) }</h1>
                    </div>
                </div>
                <div className="row patient-info-input-container">
                    <div className="col-12">
                        <h2 className="form-section-heading">{translateText(t && translate, "Patient Information (as it appears on your photo ID)", t) } </h2>
                    </div>
                    <div className="col-12 col-md-6 form-group">
                        <Select id={genderInputId} required value={this.state.gender}
                            onChange={(e) => { this.onInputChange('gender', e.target.value); }}
                            options={[{ label: translateText(t && translate, "Female", t), value: "Female" }, { label: translateText(t && translate, "Male", t), value: "Male" }]}
                            placeholder={translateText(t, "Gender", t)} inputErrorMsg={translateText(t && translate, "Please select a gender.", t) }
                            showAsInvalid={this.state.showAsInvalid && !this.state.validGender}
                            ref="gender" onFocus={(e) => { this.onGenderFocus(e); }}
                        />
                    </div>
                    <div className="col-12 col-md-6 form-group">
                        <DatePicker placeholder={translateText(translate, "Date of Birth (MM/DD/YYYY)", t)} dobId={dobInputId} required value={this.stupidDatePickerHack(this.state.dateOfBirth)} yearsBackward={140} maxDate={new Date()}
                            onChange={(day, isValid) => {
                                this.onInputChange('dateOfBirth',
                                    !isValid ? '' : `${day.getFullYear()}-${(day.getMonth() + 1).toString().padStart(2, "0")}-${day.getDate().toString().padStart(2, "0")}`);
                            }}
                            showAsInvalid={this.state.showAsInvalid && !this.state.validDob}
                            translate={translate}
                        />
                    </div>
                    <div className="col-12 col-md-6 form-group">
                        <SSNInput id={ssnInputId} value={this.state.nationalIdentifier}
                            onChange={(e) => { this.onInputChange('nationalIdentifier', e.target.value); }}
                            placeholder={translateText(t && translate, "Social Security Number (optional)", t)}
                            showAsInvalid={this.state.showAsInvalid && !this.state.validSsn}
                            ref="SSN"
                        />
                    </div>
                    <div className="col-12 col-md-6 form-group">
                        <PhoneNumber id={phoneInputId} required value={this.state.patientPhone}
                            onChange={(e) => { this.onInputChange('patientPhone', e.target.value); }}
                            placeholder={translateText(t && translate, "Phone Number", t)}
                            showAsInvalid={this.state.showAsInvalid && !this.state.validPhone}
                            ref="phone"
                        />
                    </div>
                </div>
                <div className="row">
                    {renderEmail &&
                        <div className="col-12 col-md-6 form-group">
                            <Email placeholder={translateText(t && translate, "Email Address", t)} id={emailInputId} value={email.value} name="email" required
                                onChange={(e, isValid) => this.setState({ email: { value: e.target.value, isValid } })}
                                showAsInvalid={this.state.showAsInvalid && !this.state.email.isValid}
                            />
                        </div>
                    }
                    <div className={`col-12 form-group mailing-address-input-container ${!isShowManualAddress ? "" : " hidden"} ${renderEmail ? " col-md-6" : ""}`}>
                        <LocationSearchInput
                            placeholder={translateText(t && translate, "Mailing Address", t)} required id={addressInputId}
                            notifyToEnterAddressManually={this.notifyToEnterAddressManually}
                            onChange={(address, components) => {
                                if (components) {
                                    this.setState({ mailingAddress: components, validMailingAddress: true });
                                }
                                else {
                                    this.setState({ mailingAddress: { streetNumber: '', street: '', street2: '', city: '', state: 'TX', zip: '' }, validMailingAddress: false });
                                }
                            }}
                            showAsInvalid={this.state.showAsInvalid && !this.state.validMailingAddress}
                            address={this.state.mailingAddress}
                            ref="address"
                        />
                    </div>
                </div>
                {isShowManualAddress && <>
                    <div className="row manual-mailing-address-input-container">
                        <div className="col-12 col-md-2 form-group">
                            <GenericInput required value={mailingAddress.streetNumber}
                                onChange={(e, value, isValid) => { this.setState({ mailingAddress: { ...mailingAddress, streetNumber: e.target.value }, isStreetNumberValid: isValid }); }}
                                placeholder={translateText(t & translate, "Street Number", t) }
                                showAsInvalid={this.state.showAsInvalid && !this.state.isStreetNumberValid}
                            />
                        </div>
                        <div className="col-12 col-md-4 form-group">
                            <GenericInput required value={mailingAddress.street}
                                onChange={(e, value, isValid) => { this.setState({ mailingAddress: { ...mailingAddress, street: e.target.value }, isStreetValid: isValid }); }}
                                placeholder={translateText(t, "Street Name", t) } 
                                showAsInvalid={this.state.showAsInvalid && !this.state.isStreetValid}
                            />
                        </div>
                        <div className="col-12 col-md-6 form-group">
                            <GenericInput value={mailingAddress.street2} onChange={(e) => { this.setState({ mailingAddress: { ...mailingAddress, street2: e.target.value } }); }} placeholder="Street Address 2 (optional)" />
                        </div>
                        <div className="col-12 col-md-5 form-group">
                            <GenericInput required value={mailingAddress.city}
                                onChange={(e, value, isValid) => { this.setState({ mailingAddress: { ...mailingAddress, city: e.target.value }, isCityValid: isValid }); }}
                                placeholder={translateText(t, "City", t)} 
                                showAsInvalid={this.state.showAsInvalid && !this.state.isCityValid}
                            />
                        </div>
                        <div className="col-12 col-md-4 form-group">
                            <Select required value={mailingAddress.state}
                                onChange={(e, value, isValid) => { this.setState({ mailingAddress: { ...mailingAddress, state: e.target.value }, isStateValid: isValid }); }}
                                options={Tools.getStates()} placeholder={translateText(t, "State", t)} 
                                showAsInvalid={this.state.showAsInvalid && !this.state.isStateValid}
                            />
                        </div>
                        <div className="col-12 col-md-3 form-group">
                            <ZipCode placeholder={translateText(t && translate, "ZIP", t)} value={mailingAddress.zip} name="zipCode" required
                                onChange={(e, isValid) => { this.setState({ mailingAddress: { ...mailingAddress, zip: e.target.value }, isZipValid: isValid }); }}
                                showAsInvalid={this.state.showAsInvalid && !this.state.isZipValid}
                            />
                        </div>
                    </div>
                </>}
                <div className="row patient-ins-input-container">
                    <div className="col-12">
                        <h2 className="form-section-heading">{translateText(t && translate, "Patient Insurance Information", t)}</h2>
                        <p className="ins-disclaimer">
                            {translateText(t && translate, "Prior to your appointment, please contact your insurance carrier to understand facility and provider network status and benefit coverage for your specific insurance plan.", t) }
                            </p>
                    </div>
                    <div className="col-12 form-group">
                        <Select id={insuranceInputId} required value={this.state.insuranceName}
                            onChange={(e) => { this.onInputChange('insuranceName', e.target.value); }}
                            options={insurancePlans} placeholder={translateText(t && translate, "Insurance", t) }
                            showAsInvalid={this.state.showAsInvalid && !this.state.validInsurance}
                        />
                    </div>
                </div>

                {
                    this.state.insuranceName.toLowerCase() === "not listed" &&
                    <div className="row patient-info-input-container">
                        <div className="col-12 form-group">
                            <GenericInput id={notListedInsuranceInputId} required value={this.state.notListedInsuranceName}
                                onChange={(e, isValid) => { this.setState({ notListedInsuranceName: e.target.value, validInsuranceNotListed: isValid }); }}
                                    placeholder={translateText(t && translate, "Insurance Name", t)}
                                showAsInvalid={this.state.showAsInvalid && !this.state.validInsuranceNotListed}
                            />
                        </div>
                    </div>
                }
                {
                    this.state.insuranceName !== "" && this.state.insuranceName !== "No Insurance" &&
                    <div className="row patient-info-input-container">
                        <div className="col-12 col-md-4 form-group">
                                <GenericInput value={this.state.memberId} onChange={(e) => { this.setState({ memberId: e.target.value }); }} placeholder={translateText(t && translate, "Member ID (optional)", t)} />
                        </div>
                        <div className="col-12 col-md-4 form-group">
                                <GenericInput value={this.state.subscriberId} onChange={(e) => { this.setState({ subscriberId: e.target.value }); }} placeholder={translateText(t && translate, "Subscriber ID (optional)", t)} />
                        </div>
                        <div className="col-12 col-md-4 form-group">
                                <GenericInput value={this.state.groupNumber} onChange={(e) => { this.setState({ groupNumber: e.target.value }); }} placeholder={translateText(t && translate, "Group Number (optional)", t)} />
                        </div>
                    </div>
                }
                {/*<div className="row patient-info-btn-container">
                        {this.isValid() &&
                            <div className="col-12 form-group footer-buttons">
                                <button onClick={this.createPatient} className="btn btn-primary">Continue</button>
                            </div>
                        }
                    </div>*/}
            </div>
        );
    }
}

export default PatientInfo;
